import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import PublicVisibilityFilterToggles from '@/components/buttons/PublicVisibilityFilterToggles';
import Filter from '@/components/Filter';
import { fetchCohortDatasets, updateCohortDatasetsFilter, updateCohortDatasetsFlags } from '../actions';

const CohortDatasetsFilters = ({
  category,
  className,
  code,
  commonsMode,
  fetchData,
  filterTerm,
  fluid,
  internalFlag,
  privateFlag,
  publicFlag,
  readErrors,
  updateFilterTerm,
  updateFlags,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-datasets-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, code, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, code, 1, null, false)}
    label={(
      <PublicVisibilityFilterToggles
        commonsMode={commonsMode}
        entity="datasets"
        privateFlag={privateFlag}
        internalFlag={internalFlag}
        publicFlag={publicFlag}
        updateFlags={(flags) => updateFlags(category, code, flags)}
      />
    )}
  />
);

const mapStateToProps = ({
  auth: { commonsMode },
  cohorts: { cohorts },
}, { category, code }) => {
  const { datasets } = findResult(cohorts, category, code) || {};

  return ({
    commonsMode,
    filterTerm: datasets?.filter || '',
    privateFlag: datasets?.privateFlag || false,
    internalFlag: datasets?.internalFlag || false,
    publicFlag: datasets?.publicFlag || false,
    readErrors: datasets?.readErrors || [],
  });
};

const mapDispatchToProps = {
  updateFlags: updateCohortDatasetsFlags,
  updateFilterTerm: updateCohortDatasetsFilter,
  fetchData: fetchCohortDatasets,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortDatasetsFilters);
